import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[filterValidator]'
})
export class FilterValidatorDirective {
  @Input('filterValidator') inputType: string = '';

  private emailPatten: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

  constructor(private el: ElementRef,private renderer: Renderer2) { }

  @HostListener('input', ['$event']) onInputChange(): void {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    const inputValue = inputElement.value;

    if (this.inputType == 'Email') {
      // It will not allow @ as first char
      if (inputValue == '@') { inputElement.value = ''; }

      // Remove not allowed char
      const pattern = /^[a-zA-Z0-9._%+@\-]*$/;
      if (!pattern.test(inputValue)) {
        inputElement.value = inputValue.replace(/[^a-zA-Z0-9._%+@\-]/g, '');
      }
    }

    if (this.inputType == 'Name') {
      // Remove not allowed char
      const pattern = /^[a-zA-Z0-9.,_\'\- ]*$/;
      if (!pattern.test(inputValue)) {
        inputElement.value = inputValue.replace(/[^a-zA-Z0-9.,_\'\- ]/g, '');
      }
    }

    if (this.inputType == 'Description') {
      // Remove not allowed char
      const pattern = /^[a-zA-Z0-9.,_\'\- ]*$/;
      if (!pattern.test(inputValue)) {
        inputElement.value = inputValue.replace(/[^a-zA-Z0-9.,_\'\- ]/g, '');
      }
    }
  }

  // @HostListener('blur') onBlur(): void {
  //   if (this.inputType == 'Email') {
  //     this.hideError();
  //     const inputElement = this.el.nativeElement as HTMLInputElement;
  //     const inputValue = inputElement.value;

  //     // Validate email formate
  //     const isValidEmail = this.emailPatten.test(inputValue);
  //     if (!isValidEmail) { this.showError('Invalid email address'); }
  //   }
  // }

  ngOnInit(): void {
    switch (this.inputType) {
      case 'Name':
        this.renderer.setAttribute(this.el.nativeElement,'maxLength','100');
        break;
      case 'Description':
        this.renderer.setAttribute(this.el.nativeElement,'maxLength','150');
        break;
      case 'Email':
        this.renderer.setAttribute(this.el.nativeElement,'maxLength','100');
        break;
      default:
        break;
    }
  }

  private showError(errorMessage: string) {
    this.hideError();
    const errorElement = this.renderer.createElement('div');
    this.renderer.addClass(errorElement, 'alert-danger');
    this.renderer.addClass(errorElement, 'alert');
    errorElement.textContent = errorMessage;

    this.renderer.appendChild(this.el.nativeElement.parentElement, errorElement);
  }

  private hideError() {
    const errorElement = this.el.nativeElement.parentElement.querySelector('.alert-danger');
    if (errorElement) {
      this.renderer.removeChild(this.el.nativeElement.parentElement, errorElement);
    }
  }

}
